var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Check_exito",
    "data-name": "Check exito",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_107",
    "data-name": "Rect\\xE1ngulo 107",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cancel_FILL0_wght300_GRAD0_opsz40",
    d: "M109-850.161l3.062,3.062a.581.581,0,0,0,.414.176.564.564,0,0,0,.424-.176.575.575,0,0,0,.18-.419.575.575,0,0,0-.18-.419L109.839-851l3.062-3.062a.581.581,0,0,0,.176-.414.564.564,0,0,0-.176-.424.575.575,0,0,0-.419-.18.575.575,0,0,0-.419.18L109-851.837l-3.062-3.062a.581.581,0,0,0-.414-.176.564.564,0,0,0-.424.176.575.575,0,0,0-.18.419.575.575,0,0,0,.18.419L108.163-851l-3.062,3.062a.581.581,0,0,0-.176.414.564.564,0,0,0,.176.424.575.575,0,0,0,.419.18.575.575,0,0,0,.419-.18ZM109-842a8.721,8.721,0,0,1-3.5-.709,9.128,9.128,0,0,1-2.863-1.931,9.124,9.124,0,0,1-1.932-2.862A8.713,8.713,0,0,1,100-851a8.767,8.767,0,0,1,.709-3.51,9.025,9.025,0,0,1,1.931-2.858,9.192,9.192,0,0,1,2.862-1.924A8.713,8.713,0,0,1,109-860a8.767,8.767,0,0,1,3.51.709,9.091,9.091,0,0,1,2.858,1.923,9.087,9.087,0,0,1,1.924,2.857A8.758,8.758,0,0,1,118-851a8.722,8.722,0,0,1-.709,3.5,9.2,9.2,0,0,1-1.923,2.863,9.02,9.02,0,0,1-2.857,1.932A8.758,8.758,0,0,1,109-842Zm0-1.19a7.526,7.526,0,0,0,5.536-2.278A7.539,7.539,0,0,0,116.81-851a7.534,7.534,0,0,0-2.273-5.536A7.534,7.534,0,0,0,109-858.809a7.539,7.539,0,0,0-5.532,2.273A7.526,7.526,0,0,0,101.191-851a7.531,7.531,0,0,0,2.278,5.531A7.531,7.531,0,0,0,109-843.19ZM109-851Z",
    transform: "translate(-96.001 863.998)",
    fill: "#d6073f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckError);
export default __webpack_public_path__ + "static/media/check-error.b0f761431f03fb8203451a51a641be5c.svg";
export { ForwardRef as ReactComponent };